import { useMediaQuery } from "@mui/material";
import { List, Datagrid, TextField, SimpleList, ReferenceField, useStore } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { POSTGRADUATE_COURSES, SpecialistServicePath } from "utils/constants";
import BackButtonToolbar from "features/BackButtonToolbar";
import { MobileListRow } from "features/MobileListRow";
import { settings } from "app";
import { POSTGRADUATE_FILTERS_KEY } from "../PostgraduateCourses/List";

const ListPostgraduateCoursesAll = props => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  // Read-only consumer of the committed year set on the main postgraduate courses list.
  const [filters] = useStore(POSTGRADUATE_FILTERS_KEY, null);
  const year = filters?.year ?? null;
  return (
    <>
      {<BackButtonToolbar />}
      <List
        {...props}
        title="Финализиране на следдипломни курсове"
        resource={`${SpecialistServicePath}${POSTGRADUATE_COURSES}/all`}
        filter={{ Year: year ? Number(year) : null }}
        exporter={false}
      >
        {isMobile ? (
          <SimpleList
            linkType={false}
            sx={settings.style.mobileList}
            primaryText={record => <MobileListRow fields={[{ label: "Име", value: record.name }]} />}
            secondaryText={record => (
              <div>
                <MobileListRow fields={[{ label: "ID", value: record.id }]} />
                <MobileListRow fields={[{ label: "Номер", value: record?.number || "N/A" }]} />
                <MobileListRow fields={[{ label: "Година", value: record.year }]} />
                <MobileListRow
                  fields={[
                    {
                      label: "Катедра",
                      value: (
                        <ReferenceField
                          source="departmentId"
                          reference={administrationRequests.getDepartmentsSelect()}
                          label="Катедра"
                          sortable={false}
                        >
                          <TextField source="name" />
                        </ReferenceField>
                      ),
                    },
                  ]}
                />
                <MobileListRow fields={[{ label: "Тип", value: record.typeNameBg }]} />
              </div>
            )}
          />
        ) : (
          <Datagrid bulkActionButtons={false}>
            <TextField
              source="id"
              label="ID"
              sortable={false}
            />
            <TextField
              source="number"
              label="Номер"
              sortable={false}
            />
            <TextField
              source="year"
              label="Година"
              sortable={false}
            />
            <ReferenceField
              source="departmentId"
              reference={administrationRequests.getDepartmentsSelect()}
              label="Катедра"
              sortable={false}
            >
              <TextField source="name" />
            </ReferenceField>
            <TextField
              source="name"
              label="Име"
              sortable={false}
            />

            <TextField
              source="typeNameBg"
              label="Тип"
              sortable={false}
            />
          </Datagrid>
        )}
      </List>
    </>
  );
};

export default ListPostgraduateCoursesAll;
